import { PropsWithChildren } from "react";
import { Badge } from "./badge";
import { P } from "./typography";

interface DataInfoProps extends PropsWithChildren {
  label?: string;
  value?: string | number;
}

type Variant =
  | "success"
  | "destructive"
  | "warning"
  | "default"
  | "rfsDraft"
  | "rfsPrepare"
  | "rfsReview"
  | "rfsRejected"
  | "rfsGenerate"
  | "rfsCancelled"
  | "failed";

// eslint-disable-next-line react-refresh/only-export-components
export const statusVariantMap: Record<string, Variant> = {
  Validated: "success",
  Unvalidated: "destructive",
  Validating: "warning",
  "Partially Validated": "warning",
  "Validation Bypassed": "warning",
  Optional: "default",
  Loading: "default",
  Submitted: "rfsPrepare",
  "Not Submitted": "rfsCancelled",

  "Draft (Invalid)": "rfsDraft",
  "Prepare & Validate": "rfsPrepare",
  "In Review": "rfsReview",
  Rejected: "rfsRejected",
  "Generate HPDB": "rfsGenerate",
  Cancelled: "rfsCancelled",
  Failed: "failed",
};

export function DataInfo({ label = "", value, children }: DataInfoProps) {
  return (
    <div className="break-inside-avoid-column">
      <P className="text-sm font-semibold dark:text-neutral-300">{label}:</P>
      {value && (
        <P className="min-h-6 break-words text-neutral-700 dark:text-neutral-400">
          {value}
        </P>
      )}
      {value === null && "-"}
      {children}
    </div>
  );
}

export function DataInfoWithBadge({ label = "", value = "" }: DataInfoProps) {
  const variant = statusVariantMap[value] || "default";

  return (
    <div className="break-inside-avoid-column">
      {label && (
        <P className="text-sm font-semibold dark:text-neutral-300">{label}:</P>
      )}
      <Badge variant={variant}>{value}</Badge>
    </div>
  );
}
